export default "../css/c51b145d8cf66a74cc74bd053b9504a5.ttf";